export default [
  {
    path: '/dashboard-invoice',
    name: 'dashboardInvoice',
    redirect: { name: 'dashboardSatya', query: { aba: 'invoice' } }
  }
];
